import React from "react";
import type { BannerConfig } from "../../lib/bannerConfig";

interface BannerHeroProps {
  banner: BannerConfig;
  className?: string;
  children?: React.ReactNode;
}

export function BannerHero({ banner, className = "", children }: BannerHeroProps) {
  const hasImage = banner.banner_enabled && Boolean(banner.banner_image_url);
  const titleLines = banner.banner_title.split("\n");
  const bodyLines = banner.banner_body.split("\n").filter(Boolean);

  return (
    <section className={`banner-hero ${hasImage ? "with-image" : "fallback"} ${className}`}>
      <div
        className="banner-media-slot"
        style={hasImage ? { backgroundImage: `url(${banner.banner_image_url})` } : undefined}
        aria-label={hasImage ? "Banner image" : "Banner fallback"}
      />
      <div className="banner-hero-content">
        <span className="hero-kicker">龍來喬</span>
        <h1>
          {titleLines.map((line) => <span key={line}>{line}</span>)}
        </h1>
        <p className="banner-subtitle">{banner.banner_subtitle}</p>
        <div className="banner-body-lines">
          {bodyLines.map((line) => <p key={line}>{line}</p>)}
        </div>
        <div className="banner-actions">
          {banner.banner_cta_text && banner.banner_cta_link ? (
            <a className="primary-cta" href={banner.banner_cta_link}>{banner.banner_cta_text}</a>
          ) : null}
          {children}
        </div>
      </div>
    </section>
  );
}
